import PropTypes from 'prop-types';

export const Breakpoints = {
    xxsmall: 0,
    xsmall: 375,
    small: 768,
    medium: 1024,
    large: 1280,
    xlarge: 1440,
    xxlarge: 1520,
};

export const GridPropTypes = {
    breakpointsOfType: type => PropTypes.shape({
        xxsmall: type,
        xsmall: type,
        small: type,
        medium: type,
        large: type,
        xlarge: type,
        xxlarge: type,
    }),
};

export const GridSize = 4;

export const MaxWidth = 1280;

export const NumColumns = 24;
